import React, { useState, useEffect, SetStateAction, Dispatch } from 'react';
import Modal from './Modal';
import { isIosApp } from '../utils/userStatus';
import { OrderFilterState, initialPageNum } from '../trade-history/OrderList';
import { updateRoutigList } from '../trade-history/PaginationOrderList';

import * as api from 'config/api';
import * as consts from 'config/consts';

type OrderFilterModalProps = {
  brokers: api.GetUserBrokerResultItem[] | undefined;
  targetYM: string[];
  getOrderSetting: (
    brokers: api.GetUserBrokerResultItem[] | undefined
  ) => OrderFilterState;
  updateOrderFilter: (filter: OrderFilterState) => void;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  refetchOrders: (pageNum?: number) => void;
};

export const OrderFilterModal: React.FC<OrderFilterModalProps> = props => {
  const {
    brokers,
    targetYM,
    getOrderSetting,
    updateOrderFilter,
    setShowModal,
    refetchOrders,
  } = props;

  const initialInpuFilter = getOrderSetting(undefined);
  const [inputFilter, setInputFilter] = useState<OrderFilterState>(
    initialInpuFilter
  );

  // 期間
  const fromYM = targetYM.map((value, index) => {
    const y = value.substr(0, 4);
    const m = Number(value.substr(4, 2)).toString();
    return (
      <option value={value.substr(0, 6)} key={index}>{`${y}年${m}月`}</option>
    );
  });
  const toYM = targetYM.map((value, index) => {
    const y = value.substr(0, 4);
    const m = Number(value.substr(4, 2)).toString();
    return (
      <option value={value.substr(0, 6)} key={index}>{`${y}年${m}月`}</option>
    );
  });

  const onChangeFromYM = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setInputFilter({ ...inputFilter, FromYM: event.target.value });
  };
  const onChangeToYM = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setInputFilter({ ...inputFilter, ToYM: event.target.value });
  };

  // 商品
  const productItems = [
    {
      id: consts.productTypes.国内株式,
      text: '国内株',
      name: 'chkStock',
      checked: inputFilter.chkStock,
    },
    {
      id: consts.productTypes.外国株式,
      text: '外国株',
      name: 'chkFforeignStock',
      checked: inputFilter.chkFforeignStock,
    },
    {
      id: consts.productTypes.投資信託,
      text: '投信',
      name: 'chkInvestmentTrust',
      checked: inputFilter.chkInvestmentTrust,
    },
    {
      id: consts.productTypes['国内ETF・ETN'],
      text: '国内ETF・ETN',
      name: 'chkEtfEtn',
      checked: inputFilter.chkEtfEtn,
    },
    {
      id: consts.productTypes['外国ETF・ETN'],
      text: '外国ETF・ETN',
      name: 'chkForeignEtfEtn',
      checked: inputFilter.chkForeignEtfEtn,
    },
    {
      id: consts.productTypes.国内REIT,
      text: '国内REIT',
      name: 'chkReit',
      checked: inputFilter.chkReit,
    },
    {
      id: consts.productTypes.外国REIT,
      text: '外国REIT',
      name: 'chkForeignReit',
      checked: inputFilter.chkForeignReit,
    },
    {
      id: consts.productTypes.国内EB,
      text: '国内EB',
      name: 'chkEb',
      checked: inputFilter.chkEb,
    },
    {
      id: consts.productTypes.外国EB,
      text: '外国EB',
      name: 'chkForeignEb',
      checked: inputFilter.chkForeignEb,
    },
    {
      id: consts.productTypes.未上場株式,
      text: '未上場株',
      name: 'chkUnlistedStock',
      checked: inputFilter.chkUnlistedStock,
    },
    {
      id: consts.productTypes.国内債券,
      text: '国内債券',
      name: 'chkBond',
      checked: inputFilter.chkBond,
    },
    {
      id: consts.productTypes.外国債券,
      text: '外国債券',
      name: 'chkForeignBond',
      checked: inputFilter.chkForeignBond,
    },
    {
      id: consts.productTypes.不動産,
      text: '不動産',
      name: 'chkRealEstate',
      checked: inputFilter.chkRealEstate,
    },
    {
      id: consts.productTypes.その他,
      text: 'その他',
      name: 'chkOther',
      checked: inputFilter.chkOther,
    },
  ];

  const [isProductAllSelect, setIsProductAllSelect] = useState<boolean>(
    inputFilter.chkProductAll
  );
  const [isProductAllShow, setIsProductAllShow] = useState<boolean>(false);

  const onChangeProduct = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updFilter = {
      ...inputFilter,
      ...{ [event.target.dataset.name as string]: event.target.checked },
      ...{ chkProductAll: false },
    };

    if (isProductAllSelect) {
      setIsProductAllSelect(false);
    }

    setInputFilter({ ...updFilter });
  };

  const onChangeProductAll = () => {
    const newInputFilter = {
      ...inputFilter,
      chkStock: false,
      chkFforeignStock: false,
      chkInvestmentTrust: false,
      chkEtfEtn: false,
      chkForeignEtfEtn: false,
      chkReit: false,
      chkForeignReit: false,
      chkEb: false,
      chkForeignEb: false,
      chkUnlistedStock: false,
      chkBond: false,
      chkForeignBond: false,
      chkRealEstate: false,
      chkOther: false,
      chkProductAll: !isProductAllSelect,
    };
    setInputFilter(newInputFilter);
    setIsProductAllSelect(prev => !prev);
  };

  const displayCount = 4;
  const chkProductItems = productItems.map((item, index) => {
    if (!isProductAllShow && index >= displayCount) {
      return <></>;
    } else {
      return (
        <label
          className="ui-checkbox-button-sm theme-simple flex flex-row items-center ml-2 rounded cursor-pointer"
          htmlFor={`ofm_chkProduct_${index}`}>
          <input
            id={`ofm_chkProduct_${index}`}
            type="checkbox"
            checked={item.checked}
            data-name={item.name}
            onChange={onChangeProduct}
          />
          <div className="ui-checkbox-button-text bg-bluegray-50">
            <div className="text-sm text-left text-gray-800">{item.text}</div>
          </div>
        </label>
      );
    }
  });

  // 取引
  const orderItems = [
    {
      text: '現物売り',
      name: 'chkSettlementSpotSell',
      isReturn: true,
      checked: inputFilter.chkSettlementSpotSell,
    },
    {
      text: '現物買い',
      name: 'chkSpotBuy',
      isReturn: false,
      checked: inputFilter.chkSpotBuy,
    },
    {
      text: '信用返売',
      name: 'chkSettlementMerginSell',
      isReturn: true,
      checked: inputFilter.chkSettlementMerginSell,
    },
    {
      text: '信用返買',
      name: 'chkSettlementMerginBuy',
      isReturn: true,
      checked: inputFilter.chkSettlementMerginBuy,
    },
    {
      text: '信用売り',
      name: 'chkMerginSell',
      isReturn: false,
      checked: inputFilter.chkMerginSell,
    },
    {
      text: '信用買い',
      name: 'chkMerginBuy',
      isReturn: false,
      checked: inputFilter.chkMerginBuy,
    },
  ];

  const [isOrderAllSelect, setIsOrderAllSelect] = useState<boolean>(
    inputFilter.chkOrderAll
  );

  const onChangeOrder = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updFilter = {
      ...inputFilter,
      ...{ [event.target.dataset.name as string]: event.target.checked },
      ...{ chkOrderAll: false },
    };

    if (isOrderAllSelect) {
      setIsOrderAllSelect(false);
    }

    // 区分指定で、決済注文の全てが解除あれば、[決済のみ表示]を解除
    if (
      !updFilter.chkSettlementMerginBuy ||
      !updFilter.chkSettlementMerginSell ||
      !updFilter.chkSettlementSpotSell
    ) {
      updFilter.chkSettlement = false;
    } else if (
      updFilter.chkSettlementMerginBuy &&
      updFilter.chkSettlementMerginSell &&
      updFilter.chkSettlementSpotSell &&
      !updFilter.chkSpotBuy &&
      !updFilter.chkMerginBuy &&
      !updFilter.chkMerginSell
    ) {
      updFilter.chkSettlement = true;
    } else {
      updFilter.chkSettlement = false;
    }

    setInputFilter({ ...updFilter });
  };

  const onChangeSettlement = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    const newInputFilter = {
      ...inputFilter,
      chkSettlement: checked,
      chkSettlementSpotSell: checked,
      chkSettlementMerginBuy: checked,
      chkSettlementMerginSell: checked,
      chkMerginBuy: false,
      chkMerginSell: false,
      chkSpotBuy: false,
    };

    setIsOrderAllSelect(false);
    setInputFilter(newInputFilter);
  };

  const onChangeOrderAll = () => {
    const newInputFilter = {
      ...inputFilter,
      chkSettlement: false,
      chkMerginBuy: false,
      chkMerginSell: false,
      chkSettlementMerginBuy: false,
      chkSettlementMerginSell: false,
      chkSettlementSpotSell: false,
      chkSpotBuy: false,
      chkOrderAll: !isOrderAllSelect,
    };
    setInputFilter(newInputFilter);
    setIsOrderAllSelect(prev => !prev);
  };

  const chkOrderItems = orderItems.map((item, index) => {
    return (
      <label
        className="ui-checkbox-button-sm theme-simple flex flex-row items-center ml-2 rounded cursor-pointer"
        htmlFor={`ofm_chkOrder_${index}`}>
        <input
          id={`ofm_chkOrder_${index}`}
          type="checkbox"
          checked={item.checked}
          data-name={item.name}
          onChange={onChangeOrder}
        />
        <div className="ui-checkbox-button-text bg-bluegray-50">
          {item.isReturn ? (
            <div className="px-2 mr-1 text-sm text-white bg-bluegray-400 rounded-full">
              決済
            </div>
          ) : (
            <></>
          )}
          <div className="text-sm text-left text-gray-800">{item.text}</div>
        </div>
      </label>
    );
  });

  // 証券会社
  const securityItems = [
    {
      id: consts.MONOBrokerIds.SBI証券,
      name: 'chkSecuritySBI',
      checked: inputFilter.chkSecuritySBI,
    },
    {
      id: consts.MONOBrokerIds.楽天証券,
      name: 'chkSecurityRakuten',
      checked: inputFilter.chkSecurityRakuten,
    },
    {
      id: consts.MONOBrokerIds.松井証券,
      name: 'chkSecurityMatsui',
      checked: inputFilter.chkSecurityMatsui,
    },
    {
      id: consts.MONOBrokerIds.三菱UFJeスマート証券,
      name: 'chkSecurityAuKabuCom',
      checked: inputFilter.chkSecurityAuKabuCom,
    },
    {
      id: consts.MONOBrokerIds.野村證券,
      name: 'chkSecurityNomura',
      checked: inputFilter.chkSecurityNomura,
    },
  ];

  const [isSecurityAllSelect, setIsSecurityAllSelect] = useState<boolean>(
    inputFilter.chkSecurityAll
  );

  const onChangeBroker = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updFilter = {
      ...inputFilter,
      ...{ [event.target.dataset.name as string]: event.target.checked },
      ...{ chkSecurityAll: false },
    };
    setInputFilter(updFilter);

    if (isSecurityAllSelect) {
      setIsSecurityAllSelect(false);
    }
  };

  const onChangeBrokerAll = () => {
    const newInputFilter = {
      ...inputFilter,
      chkSecurityAll: !isSecurityAllSelect,
      chkSecuritySBI: false,
      chkSecurityRakuten: false,
      chkSecurityAuKabuCom: false,
      chkSecurityMatsui: false,
      chkSecurityNomura: false,
    };
    setInputFilter(newInputFilter);
    setIsSecurityAllSelect(prev => !prev);
  };

  const brokerList = securityItems
    .map(item => {
      const broker = brokers?.find(broker => broker.BrokerID === item.id);
      return !broker
        ? null
        : {
            chkStatus: item,
            brokerInfo: broker,
          };
    })
    .filter(x => x) as {
    chkStatus: {
      id: string;
      name: string;
      checked: boolean;
    };
    brokerInfo: api.GetUserBrokerResultItem;
  }[];

  const chkSecurityItems = brokerList.map(item => {
    return (
      <label
        className="ui-checkbox-button-sm theme-simple flex flex-row items-center ml-2 rounded cursor-pointer"
        htmlFor={item.brokerInfo.BrokerName}>
        <input
          id={item.brokerInfo.BrokerName}
          type="checkbox"
          checked={item.chkStatus.checked}
          data-name={item.chkStatus.name}
          onChange={onChangeBroker}
        />
        <div className="ui-checkbox-button-text bg-bluegray-50">
          <div className="text-sm text-left text-gray-800">
            {item.brokerInfo.BrokerName}
          </div>
        </div>
      </label>
    );
  });

  useEffect(() => {
    if (
      inputFilter.FromYM === '' &&
      inputFilter.ToYM === '' &&
      targetYM.length > 0
    ) {
      setInputFilter({
        ...inputFilter,
        FromYM: targetYM[0],
        ToYM: targetYM[targetYM.length - 1],
      });
    }
  }, [inputFilter, props, targetYM]);

  const onClose = () => {
    setShowModal(false);
  };

  const onClear = () => {
    setInputFilter({
      FromYM: targetYM[0],
      ToYM: targetYM[targetYM.length - 1],
      chkProductAll: false,
      chkStock: false,
      chkFforeignStock: false,
      chkInvestmentTrust: false,
      chkEtfEtn: false,
      chkForeignEtfEtn: false,
      chkReit: false,
      chkForeignReit: false,
      chkEb: false,
      chkForeignEb: false,
      chkUnlistedStock: false,
      chkBond: false,
      chkForeignBond: false,
      chkRealEstate: false,
      chkOther: false,
      chkOrderAll: false,
      chkSettlement: false,
      chkSettlementSpotSell: false,
      chkSettlementMerginBuy: false,
      chkSettlementMerginSell: false,
      chkMerginBuy: false,
      chkMerginSell: false,
      chkSpotBuy: false,
      chkSecurityAll: false,
      chkSecuritySBI: false,
      chkSecurityRakuten: false,
      chkSecurityAuKabuCom: false,
      chkSecurityMatsui: false,
      chkSecurityNomura: false,
    });
    setIsProductAllSelect(false);
    setIsOrderAllSelect(false);
    setIsSecurityAllSelect(false);
  };

  const onExecute = () => {
    updateOrderFilter(inputFilter);
    refetchOrders();
    updateRoutigList(initialPageNum.toString());
    onClose();
  };

  return (
    <Modal onClose={onClose}>
      <div
        className="pt-4 max-h-modal overflow-y-auto text-bluegray-700"
        onClick={event => {
          event.stopPropagation();
        }}>
        <div className="px-4 pb-2">
          <div className="flex flex-row">
            <div className="text-lg font-bold">絞り込み</div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={onClose}
            />
          </div>

          {/* 期間 */}
          <div className="flex flex-row mt-4">
            <div className="font-bold">期間</div>
            <div className="ml-auto text-blue-700">
              <a
                href="https://support.minkabu.jp/hc/ja/articles/360060872193-%E5%8F%96%E5%BC%95%E5%B1%A5%E6%AD%B4"
                target="_blank"
                rel="noopener noreferrer">
                <div className="flex flex-row items-center justify-center">
                  <div className="text-sm">表示期間について</div>
                  <div className="icon-external-link ml-1  text-base"></div>
                </div>
              </a>
            </div>
          </div>
          <div className="flex flex-row items-center justify-between mt-2">
            <div className="relative w-full flex flex-row justify-center items-center mx-auto py-1 border rounded-lg">
              <select
                className="h-full w-full pl-2 appearance-none bg-transparent text-base cursor-pointer"
                value={inputFilter.FromYM}
                onChange={onChangeFromYM}>
                {fromYM}
              </select>
              <div className="absolute pointer-events-none inset-y-0 right-0 flex items-center pr-1">
                <i className="icon-chevron-down text-xl text-gray-700" />
              </div>
            </div>
            <div className="text-center mx-1">～</div>
            <div className="relative w-full flex flex-row justify-center items-center mx-auto py-1 border rounded-lg">
              <select
                className="h-full w-full pl-2 appearance-none bg-transparent text-base cursor-pointer"
                value={inputFilter.ToYM}
                onChange={onChangeToYM}>
                {toYM}
              </select>
              <div className="absolute pointer-events-none inset-y-0 right-0 flex items-center pr-1">
                <i className="icon-chevron-down text-xl text-gray-700" />
              </div>
            </div>
          </div>

          {/* 商品 */}
          <div className="mt-4 font-bold border-b border-bluegray-300">
            商品
          </div>
          <div className="grid grid-cols-2 ml-2 mt-2">
            <label
              className="ui-checkbox-button-sm theme-simple flex flex-row items-center ml-2 rounded cursor-pointer"
              htmlFor={`ofm_chkProduct_all`}>
              <input
                id={`ofm_chkProduct_all`}
                type="checkbox"
                checked={isProductAllSelect}
                onChange={onChangeProductAll}
              />
              <div className="ui-checkbox-button-text bg-bluegray-50">
                <div className="text-sm text-gray-800">全て</div>
              </div>
            </label>
          </div>
          <div className="grid grid-cols-2 ml-2">{chkProductItems}</div>
          <div
            className="flex flex-row items-center justify-center mt-2 text-bluegray-500 cursor-pointer"
            onClick={() => setIsProductAllShow(prev => !prev)}>
            <div className="text-xs">全て表示する</div>
            <div
              className={`${
                isProductAllShow ? 'icon-chevron-up' : 'icon-chevron-down'
              }`}></div>
          </div>

          {/* 取引 */}
          <div className="flex flex-row items-center justify-between mt-4 border-b border-bluegray-300">
            <div className="font-bold">取引</div>
            <label
              className="ui-checkbox-button-sm theme-simple-2 cursor-pointer"
              htmlFor="ofm_chkSettlement">
              <input
                id="ofm_chkSettlement"
                type="checkbox"
                checked={inputFilter.chkSettlement}
                onChange={onChangeSettlement}
              />
              <div className="ui-checkbox-button-text text-sm text-gray-500">
                決済のみ表示
              </div>
            </label>
          </div>
          <div className="grid grid-cols-2 ml-2 mt-2">
            <label
              className="ui-checkbox-button-sm theme-simple flex flex-row items-center ml-2 rounded cursor-pointer"
              htmlFor={`ofm_chkOrder_all`}>
              <input
                id={`ofm_chkOrder_all`}
                type="checkbox"
                checked={isOrderAllSelect}
                onChange={onChangeOrderAll}
              />
              <div className="ui-checkbox-button-text bg-bluegray-50">
                <div className="text-sm text-gray-800">全て</div>
              </div>
            </label>
          </div>
          <div className="grid grid-cols-2 ml-2">{chkOrderItems}</div>

          {/* 証券会社 */}
          {!isIosApp() && (
            <>
              <div className="mt-4 font-bold border-b border-bluegray-300">
                証券会社
              </div>
              <div className="grid grid-cols-2 ml-2 mt-2">
                <label
                  className="ui-checkbox-button-sm theme-simple flex flex-row items-center ml-2 rounded cursor-pointer"
                  htmlFor={`ofm_chkBroker_all`}>
                  <input
                    id={`ofm_chkBroker_all`}
                    type="checkbox"
                    checked={isSecurityAllSelect}
                    onChange={onChangeBrokerAll}
                  />
                  <div className="ui-checkbox-button-text bg-bluegray-50">
                    <div className="text-sm text-gray-800">全て</div>
                  </div>
                </label>
              </div>
              <div className="grid grid-cols-2 ml-2">{chkSecurityItems}</div>
            </>
          )}
        </div>
        <div className="flex flex-col pt-4 px-4 pb-2 sticky bottom-0 bg-white shadow">
          <button
            className="p-2 font-bold text-base text-white bg-tradewell rounded-lg shadow"
            onClick={onExecute}>
            この条件で絞り込み
          </button>
          <button
            className="w-full justify-center mt-2 p-2 text-sm text-bluegray-500 cursor-pointer"
            onClick={onClear}>
            条件をクリア
          </button>
        </div>
      </div>
    </Modal>
  );
};
